import { render, staticRenderFns } from "./StudentEducationTab.vue?vue&type=template&id=53a5de28"
import script from "./StudentEducationTab.vue?vue&type=script&lang=ts"
export * from "./StudentEducationTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports